import { Component, ViewChild } from '@angular/core';
import { ResetService, ProgressBarService ,CommonDataService,DataLoaderService} from '../service-call-index';
     
@Component({
  selector: 'reset-confirmation',
  templateUrl: './reset-confirmation.template.html',
  styleUrls: ['./reset-confirmation.component.css'],
})

export class ResetConfirmationComponent {
 
  constructor(private progressBarService: ProgressBarService,
    private resetService: ResetService, private commonDataService: CommonDataService, private dataLoaderService: DataLoaderService) {
  }

  resetNormal() {
    this.resetService.resetNormalExpert();
    // this.progressBarService.illuminateRed();
    this.commonDataService.progressBarColorFlag =  false;
    this.commonDataService.progressBarNewOrderColorFlag = false;
    this.commonDataService.progressBarNewOrderUpholsteryFlag = false;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/reset-confirmation/reset-confirmation.component.ts